import styled from 'styled-components';

export const CardProjectUserStyle = styled.div`
  box-sizing: border-box;
  padding: 5px 5px 10px 5px;
  margin-bottom: 10px;
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  h3 {
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;

export const WrapperCard = styled.div`
  display: flex;
  flex-flow: row wrap;

  a {
    margin-right: 5px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    padding: 5px;
    background-color: ${({ theme }) => {
      return theme.colors.white;
    }};
    color: ${({ theme }) => {
      return theme.colors.darkPrimary;
    }};
    text-decoration: none;
    transition: filter 200ms ease-in-out;
    &:hover {
      filter: brightness(85%);
    }
  }
`;

export const CardProject = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 5px;
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  padding: 5px;
  background-color: ${({ theme }) => {
    return theme.colors.white;
  }};
  color: ${({ theme }) => {
    return theme.colors.darkPrimary;
  }};

  h3 {
    margin: 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    padding-bottom: 5px;
    border-bottom: 1px solid
      ${({ theme }) => {
        return theme.colors.darkPrimary;
      }};
  }

  div {
    display: flex;
    justify-content: space-around;

    p {
      margin: 5px;
    }
  }
`;
